import React from 'react';
import { HoaSummaryItemContainer } from './hoa/HoaSummaryItemContainer';
import { LoanType } from './LoanType';
import { PropertyType } from './PropertyType';
import { OccupancyType } from './OccupancyType';
import { SolarPanels } from './SolarPanels';
import { FirstMortgagePayoffName } from './FirstMortgagePayoffName';
import { FirstMortgagePayoffAccount } from './FirstMortgagePayoffAccount';

export const OtherTab: React.FC = () => {
  return (
    <>
      <HoaSummaryItemContainer />
      <LoanType />
      <PropertyType />
      <OccupancyType />
      <SolarPanels />
      <FirstMortgagePayoffName />
      <FirstMortgagePayoffAccount />
    </>
  );
};
